import { Injectable} from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class HttpCssClient {
  private language:string;
  private headers:HttpHeaders = new HttpHeaders();
  constructor(private http: HttpClient, private router:Router) {}

  

  addHeader(key:string,value:string){
    if(this.headers.has(key)){
      this.headers = this.headers.delete(key);
      this.headers = this.headers.append(key,value)
    }else{
        this.headers = this.headers.append(key,value); 
    }
  }

  getHeader(key:string){
    if(this.headers.has(key)){
      return this.headers.get(key);
    }else{
      return null;
    }
  }

  removeHeader(key:string){
    this.headers = this.headers.delete(key);
  }

  get(url, params:HttpParams = new HttpParams(), isBlob:boolean = false, cacheable:boolean = true, returnHeaders:boolean = false):Observable<any> {    
    let headers = this.headers;
    let resType = null;
    if(params == null) params = new HttpParams();
    params = params.set("_v_",`${environment.APP_VERSION}`);
    
    if(isBlob){
        resType = 'blob';
    }

    /////////////////////////////////////////////////////////////////////////
    //                                CACHE                                //
    /////////////////////////////////////////////////////////////////////////
    let needHeaders:any = '';
    if (returnHeaders){
      needHeaders = 'response';
    }
    return this.http.get(url, {headers: headers, observe: needHeaders, params: params, responseType: resType}).pipe(catchError((error, caught) => {
        this.handleError(error);
        return throwError (error)
    }));
  }

  post(url, data):Observable<any> {
    let headers = this.headers;
    return this.http.post(url, data, {
      headers: headers,
      observe: 'response' //This is needed to get headers of the response
    });
  }

  getLanguage(){
    return this.language;
  }
  setLanguage(language:string){
    this.language = language;
  }

  private handleError(error:any){
    console.log("ERROR EN RESPUESTA: ", error);
    console.log("Request to => "+ arguments[0].url);
    console.log("Response Error => "+error.status);
    if(arguments[0].url == null){
      return false;
    }else{
      let statusCode = error.status==0?408:error.status;
      statusCode = isNaN(parseInt(statusCode))?500:statusCode;
      this.router.navigate(['/oops/'+statusCode]);
    }
  }
}